/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import {  FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap'

import CharacterKeywordValue from './CharacterKeywordValue.js'
import TrueOrFalseKeywordValue from './TrueOrFalseKeywordValue.js'
import YesNoKeywordValue from './YesNoKeywordValue.js'
import DateKeywordValue from './DateKeywordValue.js'
import NumericKeywordValue from './NumericKeywordValue.js'
import JsonKeywordValue from './JsonKeywordValue.js'

import {AppContext} from '../../AppContext';

class EditKeywordValueModal extends React.Component
{
  closing = false;
  keywordObj = null;
  queuedEdits = [];
  editorWidgetKey = null;
  originalKeywordValue = null;
  keywordValue = null;
  saveButton = undefined;

  async acceptModal(event)
  {
    if (!this.state.validValue || '' === this.originalKeywordValue)
    {
      this.setState({validValue: false});
      this.context.postNotification('info', 'Correct the errors on the page.');
      return;
    }

    if (this.keywordValue === this.originalKeywordValue)
    {
      this.props.closeModal();
      return;
    }

    let bodyData = {};
    bodyData.keywordId = this.props.keywordAndValue.keywordId;
    bodyData.keywordValue = this.keywordValue;
    bodyData.objectIds = this.props.objectIds;

    this.setState({saveButtonDisabled: true});

    if (undefined === this.props.keywordAndValue.valueId)
    {
      let result = await this.context.dbTwig.callRestAPI('dgBunker', 'assignKeyword', bodyData);
      if ('success' !== result.status)
      {
        return this.context.dbTwig.apiErrorHandler(result, 'Error assigning keyword');
      }
      if (result.jsonData.rejectedAssignment)
        this.context.postNotification('warning', 'One or more keyword assignment was rejected due to object-type restrictions.');
      else
        this.context.postNotification('info', 'Keyword assigned.');
      
      this.props.closeModal();
      this.props.refreshKeywordsAndValues();
      this.props.refreshQueryValues(bodyData.keywordId);
    }
    else
    {
      bodyData.oldValueId = this.props.keywordAndValue.valueId;

      let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setKeywordValue', bodyData);
      if ('success' !== result.status)
      {
        return this.context.dbTwig.apiErrorHandler(result, 'Error setting keyword value');
      }
      this.context.postNotification('info', 'Keyword value set.');
      this.props.closeModal();
      this.props.refreshKeywordsAndValues();
      this.props.refreshQueryValues(bodyData.keywordId);
    }
  }

  cancelModal(event)
  {
    if (this.closing) return;

    this.closing = true;
    this.props.closeModal();
  }

  constructor(props)
  {
    super();

    this.state =
    {
      keyword: '',
      openDatePicker: true,
      saveButtonDisabled: true,
      validValue: true
    }

    switch(props.keywordAndValue.keywordValueType)
    {
      case 'character':
        this.originalKeywordValue = props.keywordAndValue.characterValue;
        break;

      case 'integer':
        this.originalKeywordValue = props.keywordAndValue.integerValue;
        break;

      case 'floating point':
        this.originalKeywordValue = props.keywordAndValue.floatingPointValue;
        break;

      case 'time':
        this.originalKeywordValue = props.keywordAndValue.floatingPointValue;
        break;

      case 'date':
        this.originalKeywordValue = props.keywordAndValue.dateValue;
        break;

      case 'timestamp':
        this.originalKeywordValue = props.keywordAndValue.timestampValue;
        break;

      case 'json':
        this.originalKeywordValue = props.keywordAndValue.jsonValue;
        break;

      default:
        break;
    }

    this.cancelModal = this.cancelModal.bind(this);
    this.acceptModal = this.acceptModal.bind(this);
    this.enterPressed = this.enterPressed.bind(this);
    this.setKeywordValue = this.setKeywordValue.bind(this);
    this.setSaveButtonDisabled = this.setSaveButtonDisabled.bind(this);
  }

  enterPressed()
  {
    this.saveButton.focus();
  }

  render()
  {
    if (this.props.modalIsOpen) this.closing = false;
    
    let editorElement = this.renderEditor();

    return(
      <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal} autoFocus={false} >
        <ModalHeader toggle={this.cancelModal}>Edit Keyword Value</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="2">Keyword:</Col><Col>{this.props.keywordAndValue.keyword}</Col>
          </Row>
          <Row style={{paddingTop: "10px"}}>
            <Col>
              <FormGroup id="keywordValueFormGroup" className="form-row mb-0">
                <Col>
                  {editorElement}
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button id='saveButton' innerRef={(ref) => this.saveButton = ref} className="float-right" color="primary" 
                onClick={this.acceptModal}  disabled={this.state.saveButtonDisabled} >Save</Button>
            </Col>
            <Col><Button className="float-right" color="secondary" onClick={this.cancelModal}>Cancel</Button></Col>
          </Row>
        </ModalFooter>
      </Modal>
    )
  }

  renderCharacterEditor()
  {
    // key attribute is what React uses to compare objects to know if they need to be re-rendered
    return(
      <CharacterKeywordValue key={this.editorWidgetKey} setKeywordValue={this.setKeywordValue}
        keywordAndValue={this.props.keywordAndValue} setSaveButtonDisabled={this.setSaveButtonDisabled}
        validValue={this.state.validValue} viewType={this.props.viewType} 
      />
    );       
  }

  renderDateEditor()
  {
    // key attribute is what React uses to compare objects to know if they need to be re-rendered
    return(
      <DateKeywordValue key={this.editorWidgetKey} saveValue={this.acceptModal} viewType={this.props.viewType}
        setKeywordValue={this.setKeywordValue} openDatePicker={this.state.openDatePicker}
        keywordAndValue={this.props.keywordAndValue} setSaveButtonDisabled={this.setSaveButtonDisabled}
        validValue={this.state.validValue}  
      />
    );
  }

  renderEditor()
  {
    let kv = this.props.keywordAndValue.keywordValueType;

    if ('character' === kv) return this.renderCharacterEditor();
    if ('true or false' === kv) return this.renderTrueOrFalseEditor();
    if ('yes or no' === kv) return this.renderYesNoEditor();
    if ('date' === kv || 'timestamp' === kv || 'time' === kv) return this.renderDateEditor();
    if ('integer' === kv || 'floating point' === kv) return this.renderNumericEditor();
    if ('json' === kv) return this.renderJsonEditor();
  }

  renderJsonEditor()
  {
    return(
      <JsonKeywordValue keywordAndValue={this.props.keywordAndValue} />
    );
  }

  renderNumericEditor()
  {
    // key attribute is what React uses to compare objects to know if they need to be re-rendered

    return(
      <NumericKeywordValue key={this.editorWidgetKey} saveValue={this.acceptModal} 
        keywordAndValue={this.props.keywordAndValue} enterPressed={this.enterPressed}
        validValue={this.state.validValue} setKeywordValue={this.setKeywordValue} viewType={this.props.viewType}
        setSaveButtonDisabled={this.setSaveButtonDisabled}
      />
    );
  }

  renderTrueOrFalseEditor()
  {
    let trueChecked = false;
    let falseChecked = false;
    if ('True' === this.props.keywordAndValue.characterValue) trueChecked = true;
    if ('False' === this.props.keywordAndValue.characterValue) falseChecked = true;

    // key attribute is what React uses to compare objects to know if they need to be re-rendered
    return <TrueOrFalseKeywordValue key={this.editorWidgetKey} falseChecked={falseChecked} trueChecked={trueChecked} setKeywordValue={this.setKeywordValue} 
              setSaveButtonDisabled={this.setSaveButtonDisabled} />
  }

  renderYesNoEditor()
  {
    let yesChecked = false;
    let noChecked = false;
    if ('Yes' === this.props.keywordAndValue.characterValue) yesChecked = true;
    if ('No' === this.props.keywordAndValue.characterValue) noChecked = true;

    // key attribute is what React uses to compare objects to know if they need to be re-rendered
    return <YesNoKeywordValue key={this.editorWidgetKey} noChecked={noChecked} yesChecked={yesChecked} setKeywordValue={this.setKeywordValue} 
             setSaveButtonDisabled={this.setSaveButtonDisabled} />
  }

  setKeywordValue(value)
  {
    this.keywordValue = value;
    let validValue = ('' === value ? false : true);
    this.setState({validValue: validValue});
  }

  setSaveButtonDisabled(setting)
  {
    this.setState({saveButtonDisabled: setting});
  }
}

EditKeywordValueModal.contextType = AppContext;

export default EditKeywordValueModal
